import { differenceInCalendarDays } from 'date-fns';
import { getDeadlineTone, type DeadlineTone } from '@/features/Vacations/components/VacationApprovalCard/vacationApprovalCard.definitions';
import { createDateSafe } from '@/utils/dateUtils';
import type { DayOffRequest } from '../../../../../../shared/dpRequests';

export function getDayOffDate(request: Pick<DayOffRequest, 'days'>): string | null {
    const dates = request.days.map((day) => day.date).sort();
    return dates[0] ?? null;
}

export function formatIsoDate(iso: string | null): string {
    if (!iso) return '—';
    const [year, month, day] = iso.split('-');
    return `${day}/${month}/${year}`;
}

export function getDayOffDeadlineTone(iso: string | null, today: Date = new Date()): DeadlineTone {
    const tone = getDeadlineTone(iso, today);
    const parsed = createDateSafe(iso);
    if (parsed && differenceInCalendarDays(parsed, today) === 0) {
        return { ...tone, hint: 'vence hoje' };
    }
    return tone;
}
